export default "https://housescan.app.solease.nl/static/media/roof_insulation_2.99639e70.svg";